import type { HTMLAttributes } from 'react';

import withStyledSystem from '@m/theme/helpers/withStyledSystem';
import styled, { css } from 'styled-components';

import type { StyledSystemProps } from '@m/theme/helpers/withStyledSystem';

export type HeadingProps = HTMLAttributes<HTMLHeadingElement> & StyledSystemProps;

const commonStyles = css`
  line-height: 1;
  text-rendering: optimizeLegibility;
`;

/**
 * @deprecated Use the Heading components from chakra-ui instead.
 */
export const Heading = styled.h1<StyledSystemProps>`
  color: ${(props) => props.theme.colors.blue7};
  letter-spacing: 0.02em;
  font-size: 36px;
  font-weight: 700;
  ${commonStyles}
  ${withStyledSystem}
`;

/**
 * @deprecated Use the Heading components from chakra-ui instead.
 */
export const SubHeading = styled.h3<StyledSystemProps>`
  color: ${(props) => props.theme.colors.grey5};
  text-transform: uppercase;
  margin-bottom: 16px;
  letter-spacing: 0.125em;
  font-weight: 700;
  font-size: 14px;
  ${commonStyles}
  ${withStyledSystem}
`;
